import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'connectionEdgeStatus'
})
export class ConnectionEdgeStatusPipe implements PipeTransform {

  transform(value: any, ...args: any): unknown {
    const edgesStatus: any = this.getEdgesStatus(args);
    const classLeft = edgesStatus.left + ' fa fa-long-arrow-left fa-lg';
    const classRight = edgesStatus.right + ' fa fa-long-arrow-right fa-lg';

    return '<div class="center-content"><i aria-hidden="true" class="' + classLeft + '"></i>' +
      '<i aria-hidden="true" class="' + classRight + '"></i></div>';
  }

  private getEdgesStatus(args): object {
    const defaultStatus = {
      left: 'gray',
      right: 'gray'
    };

    return args[0] && args[0].edgesStatus ?
        args[0].edgesStatus : defaultStatus;
  }
}
